import { CSSProperties, FC, ReactNode } from "react";

const CardHeaderBG: FC<{
  className?: string;
  titile?: string | ReactNode;
  titileClassName?: string;
  children: ReactNode;
  style?: CSSProperties;
  icon?: any;
  fromPayout?: boolean;
  subText?: string;
}> = ({
  className = "",
  titile,
  titileClassName = "",
  children,
  style = {},
  icon,
  fromPayout,
  subText,
}) => {
  return (
    <>
      <div
        className={`border  ${
          fromPayout ? "" : "br-10"
        } overflow-hidden bg-white ${className}`}
        style={style}
      >
        {titile && (
          <div
            className={`card_bg_head flex gap-2 font-semibold items-center justify-between  ${titileClassName}`}
          >
            <div className="flex gap-2 items-center">
              {" "}
              {typeof icon === "string" ? (
                icon != "" ? (
                  <img src={icon} alt="icon" className="header-icon" />
                ) : (
                  ""
                )
              ) : (
                <span
                  className={`${
                    icon
                      ? "text-white bg-primary br-100 w-[20px] h-[20px] flex items-center justify-center"
                      : ""
                  }`}
                >
                  {icon}
                </span>
              )}
              <span className="fs-14">{titile}</span>
            </div>
            <span className="fs-12 color-sub-text font-medium">{subText}</span>
          </div>
        )}
        {children}
      </div>
    </>
  );
};
export default CardHeaderBG;
